import { getQueryParams, getQueryParamValueByKey, updateQueryParam } from "./queryParams";
import { scrollToElement } from "./smooth-scroll";

export const getPagesElements = (el) => el.querySelectorAll(".pagination a");

const handlePageClick = (queryParams, e) => {
    e.preventDefault();

    const queryKey = "page";

    const href = e.target.href
        ? e.target.href
        : e.target.parentElement.href
        ? e.target.parentElement.href
        : null;

    if (!href) return;

    const pageQueryParams = getQueryParams(new URL(href).search);

    const pageIndex = getQueryParamValueByKey(pageQueryParams, queryKey);

    if (!pageIndex) return;

    updateQueryParam(queryParams, queryKey, pageIndex, true, true);
};

export const setPagesEventListeners = (pagesEls, queryParams) =>
    pagesEls.forEach((p) => p.addEventListener("click", handlePageClick.bind(null, queryParams)));

export const scrollElementIntoView = (queryParams) => {
    if (queryParams.toString() !== "") scrollToElement(".app", null, false, "instant");
};
